import React from 'react';

const DedicatedIPsInput = ({ dedicatedIPs, setDedicatedIPs, ipPriceTotal, IP_PRICE_PER_UNIT }) => {
  return (
    <div className="mb-6">
      <label className="block mb-1">
        Public IP Addresses
        <span className="ml-2 text-xs text-gray-400">(GHS {IP_PRICE_PER_UNIT.toFixed(2)} each/month)</span>
      </label>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setDedicatedIPs(Math.max(0, dedicatedIPs - 1))}
          className="w-10 h-10 bg-[#033A6A] hover:bg-[#044A80] text-white rounded-lg text-xl font-bold"
        >
          −
        </button>
        <span className="text-xl font-semibold w-8 text-center">{dedicatedIPs}</span>
        <button
          type="button"
          onClick={() => setDedicatedIPs(Math.min(10, dedicatedIPs + 1))}
          className="w-10 h-10 bg-[#033A6A] hover:bg-[#044A80] text-white rounded-lg text-xl font-bold"
        >
          +
        </button>
        {dedicatedIPs > 0 && (
          <span className="text-sm text-green-400 ml-2">
            +GHS {ipPriceTotal.toFixed(2)}/month
          </span>
        )}
      </div>
      {dedicatedIPs === 0 && (
        <p className="text-xs text-gray-500 mt-1">Select 0 for shared IP (included free)</p>
      )}
    </div>
  );
};

export default DedicatedIPsInput;